import React, { useCallback, useState } from "react";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CardTileWrapper from "./CardTileWrapper";
import { InteractiveList } from "../List";
export const CardTile = React.memo((props) => {
    const { title, onClick, list, image } = props;
    const [isHoverOnTile, setHoverOnTile] = useState(false);
    const tileOnClickHandler = useCallback((event) => onClick(event, props), [onClick, props]);
    const tileMouseEnter = useCallback(() => (list === null || list === void 0 ? void 0 : list.length) && setHoverOnTile(true), [list]);
    const tileOnMouseOutHandler = useCallback(() => (list === null || list === void 0 ? void 0 : list.length) && setHoverOnTile(false), [list]);
    const listOnClickHandler = useCallback((event, data) => {
        onClick(event, data);
    }, [onClick]);
    return (React.createElement(CardTileWrapper, { className: `${isHoverOnTile ? "hoverOnContentWrapper" : ""}` },
        React.createElement(CardContent, { onMouseLeave: tileOnMouseOutHandler, onClick: tileOnClickHandler, onMouseOver: tileMouseEnter },
            React.createElement(Box, null,
                React.createElement("img", { src: image, alt: title }),
                React.createElement(Typography, { className: "cardTitle", variant: "h6", align: "center" }, title)),
            isHoverOnTile && (React.createElement(InteractiveList, { list: list, onClick: listOnClickHandler })))));
});
